<template>
    <div>


        <!-- Modal -->
        <div class="modal fade" id="addCarrinhoClonePizza" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" >Pizzas</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <form >
                        <div class="modal-body">


                            <section class="title" >
                                <h2>Montar Pizza</h2>
                            </section>



                            <!-- Sabores -->
                            <div 
                                class="card my-3 p-3 d-flex flex-colunm">
                                <div class="row">
                                    <div class="col text-center">
                                        <p>Nesta pizza você pode escolher {{clone.tamanho.qms==1?'apenas':'até'}} {{clone.tamanho.qms}} {{clone.tamanho.qms==1?'sabor':'sabores'}} </p>
                                    </div>
                                </div>
                                <div class="row" >
                                    <table class="table">
                                        <tbody>
                                            <tr
                                                v-for="(sabor, index) in formAddCarrinho.sabores"
                                                :key="index"
                                            >
                                                <td scope="row">
                                                    <div v-if="sabor.imagem" class="p-1 align-self-center">
                                                        <img class="img-thumb" :src="sabor.imagem" style="max-height: 72px ; max-width: 72px" >
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="p-1">
                                                        <h6>{{sabor.nome}}</h6>
                                                        <span style="font-weight:normal; font-size:12px">{{sabor.descricao}}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <a class="btn btn-danger" href="#"  >Excluir</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-if="formAddCarrinho.sabores.length<clone.tamanho.qms" class="form-group row">
                                    <div class="col text-center">
                                        <a class="btn b-btn" @click="modalEscolherSabor()"  href="#"> Escolher {{formAddCarrinho.sabores.length>0?'outro':''}} Sabor </a>
                                    </div>
                                </div>


                            </div>

                            
                            <!-- Bordas -->

                            <div class="card my-3 p-3 d-flex flex-colunm">
                                <div style="max-width: 300px;" class="mb-3">
                                    <h5>Tipo de borda:</h5>
                                </div>
                                <div
                                    v-for="borda in clone.bordas" :key="borda.id"
                                    class="d-flex flex-row"
                                >
                                    <template v-if="borda.disponivel==1">
                                        <div>
                                            <input type="radio" :id="'borda-'+borda.id" :value="borda" name="borda" v-model="formAddCarrinho.borda"  >
                                            <label :for="'borda-'+borda.id">{{borda.nome}}</label>
                                        </div>
                                        <div class="ml-auto">
                                            <div style="width:110px; text-align: center ">
                                                <span >+ {{borda.valor}}</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>


                            <!-- Massa -->

                            <div class="card my-3 p-3 d-flex flex-colunm">
                                <div style="max-width: 300px;" class="mb-3">
                                    <h5>Tipo de Massa:</h5>
                                </div>
                                <div
                                    v-for="massa in clone.massas" :key="massa.id"
                                    class="d-flex flex-row"
                                >
                                    <template v-if="massa.disponivel==1">
                                        <div>
                                            <input type="radio" :id="'massa-'+massa.id" :value="massa" name="massa" v-model="formAddCarrinho.massa"   >
                                            <label :for="'massa-'+massa.id">{{massa.nome}}</label>
                                        </div>
                                        <div class="ml-auto">
                                            <div style="width:110px; text-align: center ">
                                                <span >+ {{massa.valor}}</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>

                            

                            

                            <!-- OBS -->

                            <div class="card my-3 p-3 d-flex flex-colunm">
                                <div style="max-width: 300px;" class="mb-3">
                                    <h5>Alguma Observação?</h5>
                                </div>
                                <div>
                                    <textarea placeholder="Ex: Sem azeitona" v-model="formAddCarrinho.obs"></textarea>
                                </div>
                            </div>


                            <div class="d-flex flex-row">
                                <div>
                                    <div class="mb-2">
                                        Quantidade:
                                    </div>
                                    <div>
                                        <button type="button" class="btn b-btn" v-on:click="formAddCarrinho.quantidade>1?formAddCarrinho.quantidade -= 1:''"> - </button>
                                        <div class="qt"> {{formAddCarrinho.quantidade}}  </div>
                                        <button type="button" class="btn b-btn" v-on:click="formAddCarrinho.quantidade += 1" > + </button>
                                    </div>
                                </div>

                                <div class="ml-auto">
                                    <div class="mb-2">
                                        Valor Total:
                                    </div>
                                    <div>
                                        <h3>R$ </h3>
                                    </div>
                                    
                                </div>

                            </div>






                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <button type="submit" class="btn b-btn">Adicionar</button>
                        </div>
                    </form>
                </div>
            </div>


        </div>


        <!-- Modal escolher Sabor -->
        <div class="modal fade" id="escolherSabor" tabindex="1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" >Escolher Sabor</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form >
                    <div class="modal-body">

                        

                    </div>
                    
                </form>
                </div>
            </div>
        </div>

        

    </div>
</template>

<script>
import api from "../service/api";

export default {
    props: ['clone'],
    data () {
        return {
            montarPizza:[],
            formAddCarrinho: new Form({
                tipo: 2,
                tamanho:{},
                borda: {},
                massa: {},
                sabores: [],
                quantidade: 1,
                obs:''
            }),
        }
    },

    watch: {


    },

    methods: {

        async modalEscolherSabor(){
            // let obj1 = JSON.parse(JSON.stringify(prod));
            // await this.$store.dispatch('atualizarProdutoAtivo', obj1).then();
            // await this.$store.dispatch('showModalAddCarrinho').then();

            // $('#addCarrinhoClonePizza').modal('hide');

            /* setTimeout(function() {
                $('#escolherSabor').modal('show').on('hidden.bs.modal', function (e) {
                    $('#addCarrinhoClonePizza').modal('show');
                })
            }, 400); */

            $('#escolherSabor').modal('show')

        },

        

    },

    mounted () {

    },


    computed: {




    }

}
</script>

<style scoped>

.card {
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0),rgba(0,0,0,0), rgba(0,0,0,0.07));
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 0.8rem;
}

.card textarea{
    width: 100%;
    height: 100px;
    padding: 5px;
}

.escolherSabor a{
    text-decoration: none;
    cursor: pointer;
}

.escolherSabor a .card:hover{
    box-shadow: 2px 2px 6px 0px #a7a7a7;
}

.title{
    text-align: center;
}

.title img {
    margin-left: 20px;
    padding: 4px;
    border: 1px solid #9c9c9c;
    border-radius: 2px;
    object-fit: cover;
    box-shadow: 2px 2px 4px 0px #a7a7a7;
}

.qt{
    display: inline-block;
    border: 1px solid rgba(0, 0, 0, 0.20);
    font-size: 1.2rem;
    width: 35px;
    height: 30px;
    text-align: center;
}

</style>